import { ParticipationGridColDef } from '../../types';

export const lastUpdatedByColDef: ParticipationGridColDef = {
  field: 'lastModifiedBy.name',
  headerName: 'Updated By',
  filter: 'agTextColumnFilter',
  floatingFilter: true,
};
